module.exports = __webpack_public_path__ + "static/planet-argon-logo-color-d7b853deb2d6aab37f2419ce26b464f1.png";